import styled from 'styled-components';

const modalWrapper = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const list = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const listItem = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;
const key = styled.div`
  font-weight: 500;
  color: #000000;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-transform: capitalize;
  width: 30%;
`;
const value = styled.div`
  font-weight: 400;
  color: #000000;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.15px;
  width: 70%;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  p {
    margin: 0;
  }
`;

export {
  modalWrapper,
  list,
  listItem,
  key,
  value,
};
